import clsx from 'clsx';

type Props = {
  label: string;
  onClick: () => void;
  /** A node the view cannot show right now (a filter hides it): grey instead of link blue. */
  muted?: boolean;
  /** Cut a long label to one short line; the full label shows on hover. */
  truncate?: boolean;
  /** With `truncate`: cut at the row's free width instead of a short line, for labels that differ late. */
  fill?: boolean;
  /** The id of the element that says why the button is muted. */
  describedBy?: string;
};

/** A node name in the sidebar that acts on the node when clicked. */
export function NodeButton({ label, onClick, muted = false, truncate = false, fill = false, describedBy }: Props) {
  return (
    <button
      type="button"
      title={truncate ? label : undefined}
      aria-disabled={muted || undefined}
      aria-describedby={describedBy}
      className={clsx(
        'text-left hover:underline',
        muted ? 'text-zinc-500 dark:text-zinc-400' : 'text-indigo-600 dark:text-indigo-400',
        truncate && (fill ? 'min-w-0 truncate' : 'max-w-40 truncate'),
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
